import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";
const AppVersion = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  return (
    <span className="app-version">
      <Tooltip title={t("appVersion.tooltipTitle")}>
        <span>{t("appVersion.copyright", { year })} </span>
        <span className="versions">v2.2.764</span>
      </Tooltip>
    </span>
  );
};

export default AppVersion;
